/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Checkinflyerformat2Inputs */

const en_checkinflyerformat2 = /** @type {(inputs: Checkinflyerformat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Format`)
};

const de_checkinflyerformat2 = /** @type {(inputs: Checkinflyerformat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Format`)
};

/**
* | output |
* | --- |
* | "Format" |
*
* @param {Checkinflyerformat2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const checkinflyerformat2 = /** @type {((inputs?: Checkinflyerformat2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Checkinflyerformat2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_checkinflyerformat2(inputs)
	return de_checkinflyerformat2(inputs)
});
export { checkinflyerformat2 as "checkinFlyerFormat" }